import { Flex, Spinner } from "@chakra-ui/react";

export function PageLoadingSpinner({ size = "large" }: { size?: "large" | "medium" }) {
  return (
    <Flex m="auto" h="100vh" w="100%" justifyContent="center" alignItems="center">
      <Spinner variant={size === "large" ? "contentLarge" : "contentMedium"} />
    </Flex>
  );
}
